import gql from 'graphql-tag'

export const mutation = gql`
  mutation deleteAutoAttribute($id: Int!) {
    record: delete_deal_auto_attribute_by_pk(id: $id) {
      id
    }
  }
`

export default mutation
